export default ai => {
    const {
        bizData,

        project: {
            pkid: prjId,
            prjName,
            prjNo,
            sVer,
        },

        template: {
            llmId,
            pkid: promptTemplateId,
            promptTemplateCode,
            promptTemplateName,
            promptTemplateResponseMode,
            usageScenarioCode,
            usageScenarioName,
        },
    } = ai

    const workflowInstanceId = ai.getWorkflowInstanceId()

    const bizMap = {
        prjId,
        prjName,
        prjNo,
        sVer,
        ...bizData,
    }

    return {
        bizMap,
        llmId,
        workflowCode: promptTemplateCode,
        workflowName: promptTemplateName,
        workflowId: promptTemplateId,
        workflowInstanceId,
        workflowResponseMode: promptTemplateResponseMode,
        usageScenarioCode,
        usageScenarioName,
    }
}
